export const getNumberFormatter = (format, precesion) => {
  console.log("format here", format);
  console.log("precesion here ", precesion);
  // let precesion = 2;
  return number => {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion,
        maximumFractionDigits: precesion
      });
    } else {
      return "0.00";
    }
  };
};



// WEBPACK FOOTER //
// ./src/helper/currencyFormat.js